import React from "react";
import { FcGoogle } from "react-icons/fc";
import firebase from "firebase/app";
import "firebase/auth";
import { useTranslation } from "react-i18next";
import { Box, Grid, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import themeOptions from "../../services/theme-default";
import history from "../../services/history";

const useStyles = makeStyles(() => ({
  root: themeOptions.custom.Button.root,
  inner: themeOptions.custom.Button.inner,
}));

export default function GoogleLoginButton() {
  const { t, i18n } = useTranslation();
  const classes = useStyles();
  const labelText = t("Sign in with {{provider}}", {
    provider: "Google",
  });

  const loginWithGoogle = () => {
    var provider = new firebase.auth.GoogleAuthProvider();
    provider.setCustomParameters({
      client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
      redirect_uri: process.env.REACT_APP_BASE_URL + "/loginverify",
    });
    firebase.auth().languageCode = i18n.language;
    firebase
      .auth()
      .signInWithPopup(provider)
      .then(() => {
        history.push("/");
      });
  };

  return (
    <Box
      id="button-googleloginbutton"
      className={classes.root}
      px={4}
      py={2}
      border={1}
      borderColor="grey.400"
      borderRadius="4px"
      onClick={loginWithGoogle}
    >
      <Grid
        id="button-googleloginbutton"
        className={classes.inner}
        container
        direction="row"
        wrap="nowrap"
        alignItems="center"
        justifyContent="space-between"
        spacing={0}
      >
        <Grid container justifyContent="flex-start" item xs={1}>
          <FcGoogle
            id="button-googleloginbutton"
            style={{ marginLeft: "-18px" }}
            size={24}
          />
        </Grid>
        <Grid item xs={10} zeroMinWidth>
          <Typography id="button-googleloginbutton" color="inherit" noWrap>
            {labelText}
          </Typography>
        </Grid>
        <Grid item xs={1} zeroMinWidth>
          <Typography id="button-googleloginbutton" color="inherit" noWrap>
            &nbsp;
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
}
